import timing from 'DesignSystem/motion/timing';
import easingJs from 'DesignSystem/motion/easing-js'
import $ from 'jquery';
import 'jquery.easing';

const mainMenu = (_options:{
  cssSelector?:string,
  cssClassDefault?: string,
  itemTriggerSelector?: string,
  linkActiveSelector?: string,
}) => {
  const opt = {
    cssSelector: '.MainMenu',
    cssClassDefault: 'MainMenu',
    itemTriggerSelector: '.MainMenu-trigger',
    linkActiveSelector: '.MainMenu-link.isActive',
    ..._options
  };
  const classOpened = 'isOpened';
  const classOpenedAtLoad = 'isOpenedAtLoad';
  const target: string = `${opt.cssSelector}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClassDefault}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${opt.cssClassDefault}`] = true;

    // Do your stuff here
    const items: any = elt.querySelectorAll(opt.itemTriggerSelector);
    const linkActive = elt.querySelector(opt.linkActiveSelector);
    if(linkActive !==null) {
      const parentItem = linkActive.parentElement.parentElement.parentElement;
      parentItem.classList.add(classOpened);
      parentItem.classList.add(classOpenedAtLoad);
    }

    for (const item of items) {

      item.addEventListener('click', () => {
        const $siblings = $(item).closest('ul').children('li');
        if (item.parentNode.classList.contains(classOpened)) {
          collapseAllDropdown($siblings);
        } else {
          collapseAllDropdown($siblings);
          item.parentNode.classList.add(classOpened);
          $(item).next().stop().slideDown({
            duration: timing.params.std,
            easing: easingJs.params.standard,
          });
        }
      });
    }

    function collapseAllDropdown($siblings:any) {
      for (const sibling of $siblings) {
        if ($(sibling).hasClass(classOpened)) {
          $(sibling).removeClass(classOpened);
          $(sibling).children(opt.itemTriggerSelector).next().stop().slideUp({
            duration: timing.params.std,
            easing: easingJs.params.standard,
            complete: ()=> {
              const $childrensOpen = $(sibling).find(`li.${classOpened}`);
              if ($childrensOpen.length){
                $childrensOpen.removeClass(classOpened);
                $childrensOpen.children(opt.itemTriggerSelector).next().hide();
              }
            }
          });
        }
      }
    }
  }
};

export default mainMenu;
